export const bloodTypes = ['A-', 'A+', 'AB+', 'AB-', 'B-', 'B+', 'O-', 'O+'];

export const maritalStatus = [
  'Solteiro(a)',
  'Casado(a)',
  'Separado(a)',
  'Divorciado(a)',
  'Viúvo(a)',
  'União Estável',
];

export const releaseReferral = [
  'Doc. Óbito emitido pelo hospital',
  'Corpo encaminhado para IML',
  'Corpo encaminhado para o SVO',
];
